module.exports = __webpack_public_path__ + "static/media/29LTBukra-Rg.240f3ca8.otf";